import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

export type Blocker = (args: { location: Location; retry: () => void }) => void;

const useBlockNavigation = (blocker: Blocker, when = true): void => {
	const blockResult = useBlocker(when);

	useEffect(() => {
		if (blockResult.state === 'blocked') {
			blocker({
				location: blockResult.location as unknown as Location,
				retry: () => blockResult.proceed?.(),
			});
		}
	}, [blockResult, blocker]);
};

export default useBlockNavigation;
